import { Box, TextField } from "@material-ui/core";
import React, { useMemo, useState } from "react";
import SendIcon from "@material-ui/icons/Send";
import CodeIcon from "@material-ui/icons/Code";
import {
  PrimaryButton,
  SecondaryButton
} from "../../../../../../elements/Button";
import { useDevice } from "../../../../../../domain/device";
import { MESSAGE_TYPE } from "../../../../../../domain/message";
import { useApi } from "../../../../../../api";
import I18nText from "../../../../../../elements/I18nText";
import useI18nSnackbar from "../../../../../../hooks/useI18nSnackbar";

const parseJson = text => {
  const trimmed = text.trim();

  if (!trimmed) {
    return { json: null, isEmpty: true, isInvalid: false };
  }

  try {
    return { json: JSON.parse(trimmed), isEmpty: false, isInvalid: false };
  } catch (e) {
    return { json: null, isEmpty: false, isInvalid: true };
  }
};

const RawJson = React.memo(() => {
  const api = useApi();
  const { enqueueSnackbar } = useI18nSnackbar();
  const { device } = useDevice();
  const [text, setText] = useState("");
  const [isSubmitting, setSubmitting] = useState(false);

  const { json, isEmpty, isInvalid } = useMemo(() => parseJson(text), [text]);

  const handleChange = e => setText(e.target.value);

  const format = () => {
    if (json !== null) {
      setText(JSON.stringify(json, null, 2));
    }
  };

  const submit = () => {
    if (isSubmitting || isEmpty || isInvalid || json === null) {
      return;
    }

    const params = {
      type: MESSAGE_TYPE.LX_IOT,
      deviceId: device.id,
      content: JSON.stringify(json)
    };

    setSubmitting(true);

    api
      .post("/v2/messages", params)
      .then(() => {
        enqueueSnackbar("messages.responses.released", {
          variant: "success"
        });

        setSubmitting(false);
      })
      .catch(e => {
        enqueueSnackbar("messages.responses.error", {
          variant: "error"
        });

        setSubmitting(false);
      });
  };

  return (
    <>
      <Box>
        <TextField
          id="raw_json"
          fullWidth
          multiline
          minRows={8}
          maxRows={16}
          variant="outlined"
          value={text}
          onChange={handleChange}
          onBlur={format}
          error={isInvalid}
          label={
            <I18nText>devices.settings.configuration.rawJson.label</I18nText>
          }
          helperText={
            isInvalid ? (
              <I18nText>
                devices.settings.configuration.rawJson.invalid
              </I18nText>
            ) : (
              <I18nText>
                devices.settings.configuration.rawJson.helperText
              </I18nText>
            )
          }
          inputProps={{
            style: { fontFamily: "monospace", fontSize: 13 },
            spellCheck: false,
            autoComplete: "off"
          }}
        />
        <Box sx={{ display: "flex", pt: 2, justifyContent: "flex-end" }}>
          <SecondaryButton
            onClick={format}
            disabled={isEmpty || isInvalid}
            icon={<CodeIcon />}
            style={{ marginRight: 8 }}
          >
            <I18nText>actions.format</I18nText>
          </SecondaryButton>
          <PrimaryButton
            onClick={submit}
            disabled={isSubmitting || isEmpty || isInvalid}
            icon={<SendIcon />}
          >
            <I18nText>actions.send</I18nText>
          </PrimaryButton>
        </Box>
      </Box>
    </>
  );
});

export default RawJson;
